import React from "react";

export default function CitySearchFeedback({ options, loading, error, query, t }) {
  const empty = !loading && !error && query.trim().length >= 2 && options.length === 0;
  if (!error && !empty) return null;
  return (
    <div className="col-span-full">
      {error && <p role="status" className="py-2 text-sm text-red-300">{t("registration_flow.city.search_error", { defaultValue: "City search is unavailable. Please try again." })}</p>}
      {!loading && !error && query.trim().length >= 2 && options.length === 0 && (
        <p role="status" className="py-2 text-sm text-white/60">{t("registration_flow.city.no_results", { defaultValue: "No supported city found. Try another spelling or clear the search and choose a nearby large city." })}</p>
      )}
    </div>
  );
}
